import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'EDIT_PLANNED_SPENDING_INSTANCE_DIALOG';

export const editPlannedSpendingInstanceDialog = createAction(
  rootUiActions.createDialog.toString(),
  (
    freeToSpendId: string,
    cardIndex: number | null,
    startDate: string,
    filterId: string,
    spendingThisMonth: number | undefined,
    location: string,
  ) =>
    rootUiTypes.mkRootUiData({
      id: 'edit-planned-instance-dialog',
      type: DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap({ freeToSpendId, cardIndex, startDate, filterId, spendingThisMonth, location }),
    }),
);
